import { Checkbox, Form, Input } from 'components/Form';
import { Link } from 'components/Link';
import { RichText } from 'components/slices/RichText';
import { donateSchema } from 'shared/donateSchemas';
import { DonateFormShell, useDonateForm } from './DonateFormBase';

export const DonateForm = () => {
  const { error, fieldErrors, success, termsLink, successMessage, onSubmit } =
    useDonateForm({ schema: donateSchema, apiType: 'personal' });

  return (
    <DonateFormShell success={success} successMessage={successMessage}>
      <RichText>
        <h2>Doneer maandelijks</h2>
        <p>* is verplicht</p>
        <br />
      </RichText>
      <Form onSubmit={onSubmit} error={error}>
        <Input
          name="firstName"
          label="Voornaam*"
          required
          error={fieldErrors.firstName}
        />
        <Input
          name="name"
          label="Achternaam*"
          required
          error={fieldErrors.name}
        />
        <Input
          name="email"
          label="E-mailadres*"
          required
          type="email"
          error={fieldErrors.email}
        />
        <Input
          name="phone"
          label="Telefoonnummer*"
          required
          type="tel"
          error={fieldErrors.phone}
        />

        <h3>Factuuradres</h3>
        <Input
          name="street"
          label="Straatnaam*"
          required
          error={fieldErrors.street}
        />
        <Input
          name="houseNumber"
          label="Huisnummer*"
          required
          error={fieldErrors.houseNumber}
        />
        <Input
          name="postalCode"
          label="Postcode*"
          required
          error={fieldErrors.postalCode}
        />
        <Input
          name="city"
          label="Woonplaats*"
          required
          error={fieldErrors.city}
        />
        <Input name="country" label="Land" error={fieldErrors.country} />

        <h3>Gift</h3>
        <Input
          name="monthlyAmount"
          label="Giftbedrag*"
          type="number"
          placeholder="€"
          required
          error={fieldErrors.monthlyAmount}
          onKeyPress={(e) => {
            if (!/[0-9]/.test(e.key)) e.preventDefault();
          }}
        />
        <Input
          name="bankAccount"
          label="IBAN*"
          required
          error={fieldErrors.bankAccount}
        />
        <Input
          name="bankAscription"
          label="Tenaamstelling IBAN*"
          required
          error={fieldErrors.bankAscription}
        />

        <Checkbox
          name="acceptsTerms"
          required
          error={fieldErrors.acceptsTerms}
          label={
            <span>
              Ik ga akkoord met het verwerken van mijn gegevens volgens de{' '}
              <Link field={termsLink} target="_blank">
                privacy voorwaarden*
              </Link>
            </span>
          }
        />
        <p style={{ fontStyle: 'italic' }}>
          Met inzending van dit formulier geeft u Groundwork Connect toestemming
          om doorlopende incasso-opdrachten te sturen naar uw bank om doorlopend
          een bedrag van uw rekening af te schrijven. Als u het niet eens bent
          met deze afschrijving kunt u deze laten terugboeken. Neem hiervoor
          binnen acht weken na afschrijving contact op met uw bank. Vraag uw
          bank naar de voorwaarden.
        </p>
        <br />
      </Form>
      <br />
      <hr />
      <p>
        Groundwork heeft geen ANBI-status, giften zijn niet aftrekbaar voor de
        inkomstenbelasting.
      </p>
    </DonateFormShell>
  );
};
